import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "./DatePickerModal.css";

const DatePickerModal = ({ show, onHide, period, currentValue, onSelect }) => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(
    currentValue?.year || currentYear
  );

  // Update selectedYear when currentValue changes
  React.useEffect(() => {
    if (currentValue?.year) {
      setSelectedYear(currentValue.year);
    }
  }, [currentValue]);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const quarters = ["Q1", "Q2", "Q3", "Q4"];

  const generateYears = () => {
    const years = [];
    for (let i = currentYear - 10; i <= currentYear + 5; i++) {
      years.push(i);
    }
    return years;
  };

  const handleSelect = (value) => {
    let result = {};

    switch (period) {
      case "monthly":
        result = {
          year: selectedYear,
          month: value,
          display: `${months[value]} ${selectedYear}`,
          shortDisplay: `${String(value + 1).padStart(2, "0")}/${selectedYear}`,
        };
        break;
      case "quarterly":
        result = {
          year: selectedYear,
          quarter: value + 1,
          display: `${quarters[value]} ${selectedYear}`,
          shortDisplay: `${quarters[value]} ${selectedYear}`,
        };
        break;
      case "yearly":
        result = {
          year: value,
          display: `${value}`,
          shortDisplay: `${value}`,
        };
        break;
      default:
        result = { display: currentValue || "" };
    }

    onSelect(result);
    onHide();
  };

  const renderMonthPicker = () => (
    <div className="date-picker-body">
      <div className="picker-grid months-grid">
        {months.map((month, index) => (
          <button
            key={month}
            className={`picker-cell ${
              currentValue?.month === index ? "selected" : ""
            }`}
            onClick={() => handleSelect(index)}
          >
            {month.substring(0, 3)}
          </button>
        ))}
      </div>
    </div>
  );

  const renderQuarterPicker = () => (
    <div className="date-picker-body">
      <div className="picker-grid quarters-grid">
        {quarters.map((quarter, index) => (
          <button
            key={quarter}
            className={`picker-cell ${
              currentValue?.quarter === index + 1 ? "selected" : ""
            }`}
            onClick={() => handleSelect(index)}
          >
            {quarter}
          </button>
        ))}
      </div>
    </div>
  );

  const renderYearPicker = () => (
    <div className="date-picker-body">
      <div className="picker-grid years-grid">
        {generateYears().map((year) => (
          <button
            key={year}
            className={`picker-cell ${
              currentValue?.year === year ? "selected" : ""
            }`}
            onClick={() => handleSelect(year)}
          >
            {year}
          </button>
        ))}
      </div>
    </div>
  );

  const renderHeader = () => {
    if (period === "yearly") return null;

    return (
      <div className="picker-header">
        <div className="year-selector">
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
            className="year-select"
          >
            {generateYears().map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (period === "yearly") return renderYearPicker();

    switch (period) {
      case "monthly":
        return renderMonthPicker();
      case "quarterly":
        return renderQuarterPicker();
      default:
        return renderMonthPicker();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="date-picker-modal">
      <Modal.Body className="date-picker-modal-body">
        <div className="date-picker-modal-container">
          {renderHeader()}
          {renderContent()}
        </div>
      </Modal.Body>
    </Modal>
  );
};

DatePickerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  period: PropTypes.oneOf(["monthly", "quarterly", "weekly", "yearly"])
    .isRequired,
  currentValue: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
};

export default DatePickerModal;
